import { render } from "./FunctionsCatalog.vue?vue&type=template&id=745b38c0&scoped=true&ts=true"
import script from "./FunctionsCatalog.vue?vue&type=script&lang=ts"
export * from "./FunctionsCatalog.vue?vue&type=script&lang=ts"

import "./FunctionsCatalog.vue?vue&type=style&index=0&id=745b38c0&lang=scss&scoped=true"

import exportComponent from "/dati01/var/lib/jenkins/workspace/Sub_Task_Release_CE/knowage-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-745b38c0"]])

export default __exports__